export const actions = {
  setUserInfo: (data) => {
    return {
      type: "SET_USERINFO",
      payLoad: data,
    };
  },
};

const initState = {
};

const userInfoReducer = (state = initState, actions) => {
  const { type, payLoad } = actions;
  switch (type) {
    case "SET_USERINFO":
      return {
        ...state,
        ...payLoad,
      };
    default:
      return {
        ...state,
      };
  }
};
export default userInfoReducer;
